export const EquipmentEducationController = {
    index(): void {},
    show(): void {},
};
